import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
    FeatureCheckboxSelected,
    FeatureCheckboxUnselected,
} from '../../../shared/svg/components';
import { changeIsDescriptionOpened } from '../../../model/configuratorSlice';
import { getFeaturePriceText } from '../../../utils/currencyFormatter';

const FeatureItemLocked = ({
                         feature,
                         categoryId,
                         categoryType,
                         isSelected,
                         onFeatureSelected,
                     }) => {
    const { settings, userLoggedIn, currentUnit } = useSelector(state => state.configurator);

    const dispatch = useDispatch();

    return (
      <div className={`feature-item locked${feature.expired ? ' expired' : ''}`}>
        <div className="feature-title-container">
          <div className="feature-title">Opción {feature.order}</div>
          <div className="price">{getFeaturePriceText(feature, currentUnit)}</div>
        </div>
        <button
          type="button"
          disabled
          aria-disabled="true"
          aria-pressed={isSelected}
          className="feature-thumb"
        >
          <div className="image-mask">
            <div className="image-container">
              <img src={`${settings.thumbs_base_url}/${feature.thumb}`} alt="" />
            </div>
            {isSelected
                    ? <FeatureCheckboxSelected className="check" />
                    : <FeatureCheckboxUnselected className="check" />}
            {!feature.expired && (
              <div className="feature-locked">
                {feature.bathroomUnavailable && <div>{feature.bathroomUnavailable}</div>}
                {!feature.bathroomUnavailable && (
                  feature.incompatibleWith !== null ? (
                    <div className="incompatible-with">( Incompatible con: {feature.incompatibleWith} )</div>
                  ) : (
                    <div className="available-if">( Requisitos: {feature.availableIf} )</div>
                  )
                )}
              </div>
            )}
          </div>
        </button>
        {/* TODO: Use for debugging <div className="feature-name">{`${feature.name}=>${feature.id}`}</div> */}
        <div className="feature-name">{feature.name}</div>
        {/* <div className="feature-name">{`${feature.name}=>${feature.id}`}</div> */}
      </div>
    );
};

FeatureItemLocked.propTypes = {
    feature: (PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        thumb: PropTypes.string,
        order: PropTypes.number,
        price: PropTypes.string,
        bathroomUnavailable: PropTypes.string,
        expired: PropTypes.bool,
        selection_deadline: PropTypes.string,
        availableIf: PropTypes.string,
        incompatibleWith: PropTypes.string,
    })).isRequired,
    categoryId: PropTypes.string.isRequired,
    categoryType: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onFeatureSelected: PropTypes.func.isRequired,
};

export default FeatureItemLocked;
